// Login through the Iranian Tax Administration's taxpayer portal (کارپوشه، my.tax.gov.ir).
// The portal is registered for asatsp.ir and always sends the user back to
// https://my.asatsp.ir/ssocb?token=…; the backend (api/auth/sso) exchanges that one-time token
// with the portal using the same redirect address. The button is therefore offered only on
// my.asatsp.ir, where the return lands on the same origin as the session it creates.

import {accountDisabledMessage} from './accountDisabled'

export const TAX_FOLDER_SSO_LOGIN_URL = 'https://my.tax.gov.ir/SSO-Out/asatsp.ir'
export const TAX_FOLDER_SSO_HOSTNAME = 'my.asatsp.ir'
export const TAX_FOLDER_SSO_CALLBACK_PATH = '/ssocb'

const MAX_TOKEN_LENGTH = 4096

export const canUseTaxFolderSso = (hostname: string): boolean =>
  String(hostname || '')
    .trim()
    .toLowerCase() === TAX_FOLDER_SSO_HOSTNAME

export const readTaxFolderSsoToken = (searchParams: URLSearchParams): string | undefined => {
  const token = (searchParams.get('token') || '').trim()
  if (!token || token.length > MAX_TOKEN_LENGTH || /\s/.test(token)) {
    return undefined
  }
  return token
}

type HttpError = {response?: {status?: number}}

export const getTaxFolderSsoError = (error: unknown, brandName: string): string => {
  const status = (error as HttpError)?.response?.status

  if (!status) {
    return `ارتباط با سرور ${brandName} برقرار نشد. اینترنت خود را بررسی و دوباره از کارپوشه وارد شوید.`
  }

  if (status === 401 || status === 403) {
    return 'کارپوشه ورود شما را تأیید نکرد یا زمان این ورود تمام شده است. لطفاً دوباره از کارپوشه وارد شوید.'
  }

  const disabled = accountDisabledMessage(error)
  if (disabled) {
    return disabled
  }

  return `ورود از کارپوشه انجام نشد. چند لحظه بعد دوباره تلاش کنید یا با نام کاربری وارد ${brandName} شوید.`
}
